import { useContext } from "react";
import { LoadingContext } from "../contexts/loadingContext";

export const useLoader = () => {
  const context = useContext(LoadingContext);

  return context;
};
